<template>
    <section>
        <barra-titulo
            titulo="Conhecimentos de transporte"
            icone="fa fa-archive"
            :itens="breadCrumb"
        />
        <lista />
    </section>
</template>
<script>
import Lista from '@/modules/cte/domains/cte/components/Lista'
export default {
    name: 'ListaCte',
    components: {
        Lista
    },
    data() {
        return {
            breadCrumb: [
                {
                    descricao: 'CT-e',
                    url: this.$urlBase + '/conhecimentos'
                },
                {
                    descricao: 'Listar'
                }
            ],
        }
    }
}
</script>
